import Button from '@components/Button';
import TextField from '@components/TextField';
import Table from '@components/Table';
import Icon from '@material-ui/core/Icon';
import { useState, useEffect } from 'react';
import { apiClient } from '@services/api';
import Select from '@components/Select';
import { useHistory } from "react-router-dom";
import BreadCrumbs from '@components/Breadcrumbs';

const permissions = ['administrador'];

const Index = (props) => {
  document.title = `Tipos de templates - ${process.env.REACT_APP_NAME}`
  const history = useHistory();
  const [rows] = useState([]);
  const [q, setQ] = useState("");
  const [license_type, setLicenseType] = useState("all")

  //Oculta menu lateral
  useEffect(() => {
    props.setShowMenu(false)
  }, []);

  const changePageDetails = (e, id) => {
    e.preventDefault();
    history.push(`tipos/detalhe/${id}`)
  }

  const bradecrumbsConfig = [
    {
      title: 'Início',
    }
  ]

  return <>
    <div className="px-7">
      <div className="flex items-center justify-between mt-2 text-2xl text-blue mb-3">
        <div className="flex items-center">
          <Icon className="mr-2">
            accessibility
          </Icon>
          <span>Lista de tipos</span>
        </div>
        {permissions.includes(props?.theme?.permission) && <Button
          textcolor="#fff"
          padding="6px 15px"
          margintop="0px"
          width="200"
          onClick={() => history.push('/admin/central/tipos/cadastro')}
          customcolor={props.theme.color}
        >
          <Icon className="mr-2">add</Icon>
          Novo
        </Button>}
      </div>
      <div className="p-4 mt-4 bg-white border-1" style={{ borderRadius: '10px 10px 0px 0px' }}>
      </div>
      <Table
        params={{
          q, license_type
        }}
        path="/template_types"
        onRowClick={null}
        columns={[
          {
            headerName: 'Nome',
            headerClassName: 'super-app-theme--header',
            field: 'name',
            flex: 1,
            renderCell: (params) => {
              const row = params.row;
              return (<div className="w-full h-full" onClick={(e) => changePageDetails(e, row.id)} >
                {row.name}
              </div>);
            }
          },
          {
            headerName: 'Status',
            headerClassName: 'super-app-theme--header',
            field: 'status',
            headerAlign: 'right',
            align: 'right',
            flex: 1,
            renderCell: (params) => {
              const row = params.row;

              return (<div className="flex items-center pr-4 space-x-5">
                {row.status ? 'Ativo' : 'Inativo'}
              </div>);
            }
          },
        ]}
        rows={rows}
      />
    </div>
  </>
}

export default Index;
